import {
  IInvoiceSendPprompbiz,
  ISellerBilling,
  ISellerBillingRes,
  ISellerSearchBillingReq,
  ISellerSearchBillingRes,
  ISellerSearchInvoiceReq,
  ISellerSearchInvoiceRes,
  ISellerSearchPaymentReq,
  ISellerSearchPaymentRes,
} from '@/interfaces/seller';
import * as baseAdapter from './baseAdapter';

//=================================
// SELL INVOICE
//=================================

export const searchSellerInvoice = async (req: ISellerSearchInvoiceReq) => {
  const ret = await baseAdapter.post<ISellerSearchInvoiceRes>(
    '/v1/seller/invoice/inquiry',
    req
  );
  return ret;
};

export const invoiceEntry = async (req: IInvoiceSendPprompbiz) => {
  const ret = await baseAdapter.post<any>('/v1/seller/invoice/entry', req);
  return ret;
};

export const invoiceEntrys = async (req: IInvoiceSendPprompbiz[]) => {
  const ret = await baseAdapter.post<any>('/v1/seller/invoice/entrys', req);
  return ret;
};

export const searchSellerInvoicePayment = async (
  req: ISellerSearchInvoiceReq
) => {
  const ret = await baseAdapter.post<ISellerSearchInvoiceRes>(
    '/v1/seller/invoice/inquiryPayment',
    req
  );
  return ret;
};

//=================================
// SELL BILLING
//=================================

export const searchSellerBilling = async (req: ISellerSearchBillingReq) => {
  const ret = await baseAdapter.post<ISellerSearchBillingRes>(
    '/v1/seller/presentment/inquiry',
    req
  );
  return ret;
};

export const billingEntry = async (req: ISellerBilling) => {
  const ret = await baseAdapter.post<any>('/v1/seller/presentment/entry', req);
  return ret;
};

export const billingEntrys = async (req: ISellerBilling[]) => {
  const ret = await baseAdapter.post<ISellerBillingRes>(
    '/v1/seller/presentment/entrys',
    req
  );
  return ret;
};

export const searchSellerPayment = async (req: ISellerSearchPaymentReq) => {
  const ret = await baseAdapter.post<ISellerSearchPaymentRes>(
    '/v1/seller/payment/inquiry',
    req
  );
  return ret;
};

export const searchSellerPayments = async (req: ISellerSearchPaymentReq[]) => {
  const ret = await baseAdapter.post<ISellerSearchPaymentRes>(
    '/v1/seller/payment/inquiry',
    req
  );
  return ret;
};

export const confirmSellerPayment = async (req: string[]) => {
  const ret = await baseAdapter.post<ISellerSearchPaymentRes>(
    '/v1/seller/payment/confirm',
    req
  );
  return ret;
};
